import { cn } from "../utils/cn";

const MaxWidthWrapper = ({ className, children }) => {
  return (
    <div
      className={cn(
        "mx-auto w-full h-full max-w-screen-xl px-2.5 md:px-20 relative",
        className
      )}
    >
      {children}
    </div>
  );
};

export default MaxWidthWrapper;